'use strict'
// import '@babel/polyfill'
import 'babel-polyfill'
import ServiceExec from '@/common/utils/ServiceExec'
import { forEach } from 'lodash'
import queryString from 'query-string'

/**
 * 공통 API Service
 * @class BannerSvc
 */
class CommonSvc extends ServiceExec {
  /**
   *  파일업로드
   *  @param file {file} file
   */
  uploadFile(params = {}) {
    const formData = new FormData()
    forEach(params, function(value, key) {
      formData.append(key, value)
    })
    return this.multiPost(`/api/common/uploadFile`, formData).then(response => {
      return response.data
    })
  }

  downloadFile (params = {}) {
    return this.ServiceExec.request({
      method: 'GET',
      url: `/api/common/downloadFile?${queryString.stringify(params)}`,
      responseType: 'blob'
    })
  }


  /**
   *  교육 코드 조회
   */
  code(params = {}) {
    return this.get(`/api/common/education/code`, params)
      .then(response => {
        return response.data
      })
  }
}
export default new CommonSvc()
